/**
 * R1AS stove display overlay pose — docs/R1AS_STOVE_CLOCK.md
 * SoftPlan fuses the black display into floor_0_3; no separate mesh name.
 */

export const R1AS_STOVE_DISPLAY = {
  /** World meters (LabViewer centered space) */
  position: [2.025, 1.675, -3.001],
  /** Euler radians — PlaneGeometry faces +Z by default */
  rotation: [0, 0, 0],
  width: 0.17,
  height: 0.055,
};
